import type { PersonalisationItemType } from "../../../../common-deprecated/types/CommonTypes";

export const isItemFirstOfType = (items: PersonalisationItemType[], index: number): boolean => {
    const currentItem = items[index];

    // First item is always true.
    if (index === 0) return true;

    // If the previous item is another type, show type.
    // @ts-expect-error - Using expect-error instead of casting thrice
    if (currentItem.type && currentItem.type !== items[index - 1].type) return true;

    return false;
};
